import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseService } from '../../../shared/services/base.service';
import { OrganizationUrl } from '../../../shared/urls/company-account.url';
@Injectable()
export class CompanyAccountService {
    constructor(public baseService: BaseService) { }

    getCountryList() {
        return this.baseService.getAll(OrganizationUrl.ORGANIZATION_COUNTRY_HAS_DISCOUNT);
    }

    getCompanyAccountList(param) {
        return this.baseService.getData(OrganizationUrl.ORGANIZATION_SEARCH, param);
    }

    getCompanyAccountDropList(isShowAll: boolean = false) {
        return this.baseService.getData(OrganizationUrl.ORGANIZATION_DROP_DOWN_LIST, { isShowAll: isShowAll });
    }
    getCurrentDate() {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(new Date(), 'dd MMM yyyy');
    }

    generateOrgCode(name, country): string {
        if (name !== '') {
            const orgCode =
                name.substring(0, 3).toUpperCase() + country.toUpperCase();
            return orgCode;
        } else {
            return 'N/A';
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-company-accounts/company-account.service.ts